<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Username" v-model="login.username" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Password" v-model="login.password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" @click.stop="loginSubmit()">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <!-- <b-button variant="link" class="px-0">Forgot password?</b-button> -->
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <!-- <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                  <b-button variant="primary" class="active mt-3">Register Now!</b-button>
                </div>
              </b-card-body>
            </b-card> -->
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      login: {
        username: '',
        password: ''
      },
      error: '',
      busy: '',
    }
  },
  methods: {
      loginSubmit () {
        this.error = ''
        this.busy = true

        var cred = {}
        cred.username = this.login.username
        cred.password = this.login.password
        cred.grant_type = GRANT_TYPE
        cred.client_id = CLIENT_ID
        cred.client_secret = CLIENT_SECRET
        cred.scope = "*"

        axios.post(API_ROOT + 'oauth/token', cred)
            .then(response => {                 

              if (response.data.access_token) {
                  store.set('access_token', response.data.access_token)
                  window.location = "/"
                  this.busy = false        
              } else {
                  this.busy = false
                  alert('Something went wrong. please try again.')
              }

            })
            .catch(error => {
                if (error) {
                    this.busy = false
                    if (error.response && error.response.data) this.error = error.response.data
                };
            });
      },
      logout() {
        store.set('access_token','')
        window.location = "/"
      }
  }
}
</script>
